"use client";
import {useCommerceContext} from "provider/magento/context";
import React, {useState} from "react";
import Image from "next/legacy/image";
import {formatCurrencySymbol, formatPriceStyle} from "../../utilities/price";
import {sendGTMEvent} from "@next/third-parties/google";
import QuantitySelect from "../Input/QuantitySelect";
import {usePhrase} from "../../i18n";
import TrashIcon from "@heroicons/react/16/solid/TrashIcon";
import PencilIcon from "@heroicons/react/16/solid/PencilIcon";
import {useRouter} from "next/navigation";
import {useLayoutContext} from "../context";

const CartItem = ({item, store, _t}) => {

    const t = usePhrase(_t);
    const router = useRouter();
    const {closeSidebar} = useLayoutContext();

    const {cart, removeItem, updateItem} = useCommerceContext();
    const [isUpdating, setIsUpdating] = useState(false);
    const [newQty, setNewQty] = useState(item.qty);


    const getCurrentPrice = () => {
        const itemId = item.item_id;

        if (cart && (cart.totals || cart.totals_info)) {
            const totals = cart.totals || cart.totals_info;
            const items = totals.items;
            const totalItem = items.find(i => i.item_id === itemId);
            return totalItem.price_incl_tax || item.price_incl_tax || item.price;
        }

    }

    const getCurrentSubTotalPrice = () => {
        const itemId = item.item_id;

        if (cart && (cart.totals || cart.totals_info)) {
            const totals = cart.totals || cart.totals_info;
            const items = totals.items;
            const totalItem = items.find(i => i.item_id === itemId);
            return totalItem.price || totalItem.base_price || item.price;
        }

    }


    const editProductHandle = () => {
        if (window) {
            window.location.href = `${item.url}?itemId=${item.item_id}&_t=${new Date().getTime()}`;
        }
        //router.replace(`${item.url}?itemId=${item.item_id}`, {scroll: true});
        //closeSidebar();
    }

    const updateProductQtyHandle = (qty) => {
        setNewQty(qty);

        //if(item.qty===qty) return;

        setIsUpdating(true);

        updateItem(item.item_id, qty).then(res => {
            setIsUpdating(false);
        });

    }

    const removeProductHandle = () => {

        setIsUpdating(true);

        removeItem(item);

        sendGTMEvent({
            event: 'remove_from_cart',
            ecommerce: {
                currency: store?.base_currency_code,
                value: +parseFloat(parseFloat(getCurrentSubTotalPrice()).toFixed(2)*parseFloat(item?.qty)).toFixed(2),
                items: [{
                    item_id: item?.sku,
                    item_name: item?.name,
                    price: +parseFloat(getCurrentSubTotalPrice()).toFixed(2),
                    item_brand: 'NoFlyStore',
                    quantity: item?.qty
                }]
            }
        });

    }

    let qtys = [];
    [1, 2, 3, 4, 5, 6, 7, 8, 9].map(q =>
        qtys.push({value: q, label: q})
    );

    return <li key={'cart_item_' + item.item_id + '_' + item.qty}

               className={`py-4 px-2 flex flex-col  relative ${isUpdating && 'opacity-50 after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full'}`}>

        <div className={`flex mb-2`}>

            <div
                className="flex-shrink-0 w-20 h-20 relative  overflow-hidden  after:bg-[#00000005] group after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full">
                {item.image && <>
                    <Image src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + item.image}
                           alt={item.name}
                           layout="responsive"
                           height={32}
                           width={32}
                           sizes="33vw"
                           className="w-full w- object-contain object-center"/>
                </>}
            </div>

            <div className="ml-4 flex-1 flex flex-col justify-between">
                <div className={'flex flex-col justify-between'}>
                    <div className="flex">
                        <h3 className={'text-lg cart-item-name'}>{item.name}</h3>
                    </div>


                    {/*                <div className={'flex flex-row items-center mt-2'}>
                    <div><CheckCircleIcon className={'h-6 w-6 mr-1 stroke-1'}/></div>
                    <div><span className={'text-sm font-bold'}>{t('Added to cart')}</span></div>
                </div>*/}
                    <div className={`relative`}>
                        <div
                            className="relative text-xs  flex flex-col xl:grid xl:grid-cols-2 ">
                            {item.options && item.options.filter(opt => !item.hide_options.includes(opt.label)).map((o, i) =>
                                <div key={['pro', item.id, 'opt_', i].join('_')}>
                                    <b className={''}>{o.label}:</b>
                                    <i className={'ml-1'}>{o?.full_view ? o.full_view : o.value}</i>
                                </div>)}

                        </div>
                        {/*<div className={` w-full flex justify-center `}>
                            <div className={`h-[1px] w-full shadow-[rgba(0,0,15,0.5)_0px_-1px_3px_0px]  `}></div>
                            <div className={`absolute -bottom-2.5 rounded-xl bg-gray-300 `}><ChevronDownIcon
                                className={`w-5 h-5`}/></div>
                        </div>*/}
                    </div>
                </div>

            </div>

        </div>
        <div className=" flex items-end justify-between">

            <div className="flex flex-row items-center">

                <QuantitySelect _t={_t}
                                className={'text-xs cursor-pointer'}
                                options={qtys}
                                value={{value: newQty, label: newQty}}
                                onChange={(v) => updateProductQtyHandle(v.value)}
                                qtyLabel={false}
                                styles={{
                                    control: {
                                        height: '36px',
                                        border: 'none',
                                        background: '#f5f5f5',
                                        padding: '0px 2px',
                                        cursor: 'pointer',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            background: '#e7e7e7'
                                        }
                                        //fontSize: '0.75rem',
                                    },
                                    dropdownIndicator: {
                                        padding: '0px 2px 0px 0px'
                                    },
                                    valueContainer: {
                                        padding: '0px 8px'
                                    },
                                }}
                />

                <button type="button"
                        className={`bg-[#f5f5f5] flex items-center justify-between space-x-2 rounded-xl  py-2 px-2 text-sm  ml-2 lg:ml-2 cursor-pointer hover:bg-[#e7e7e7]`}
                        onClick={editProductHandle}>
                    <PencilIcon className={'w-4 h-4'}/>
                    <span>{t(`Edit`)}</span>
                </button>

                <button aria-label={t('Remove')} type="button"
                        className="bg-[#f5f5f5]  flex items-center justify-between space-x-2  rounded-xl py-2 px-2  text-sm ml-2  cursor-pointer hover:bg-[#e7e7e7]"
                        onClick={removeProductHandle}>
                    <TrashIcon className={'w-4 h-4'}/>
                    <span>{t(`Remove`)}</span>
                </button>
            </div>

            <div className="flex">
                    <span className="text-lg font-bold ">
                        {formatPriceStyle(parseFloat(getCurrentPrice()).toFixed(2), true)} {formatCurrencySymbol(cart?.currency?.store_currency_code)}
                    </span>
            </div>
        </div>
    </li>

}

export default CartItem;